import { Component } from '@angular/core';

@Component({
  selector: 'app-user-sets',
  standalone: true,
  imports: [],
  templateUrl: './user-sets.component.html',
  styleUrl: './user-sets.component.css'
})
export class UserSetsComponent {

}
